<div class="flex justify-end">
  <div class="relative w-60">
    <input
      type="text"
      [(ngModel)]="searchIssuer"
      (keydown.enter)="onSearchEnter()"
      placeholder="Search from asReportedIssuer..."
      class="border border-gray-300 rounded px-3 py-1 text-sm w-full"
      (focus)="showDropdown = filteredIssuers.length > 0"
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'searchIssuer')"
    />
    <div
      *ngIf="showDropdown && filteredIssuers.length > 0"
      class="absolute z-50 mt-1 w-full border border-gray-300 bg-white shadow-md max-h-60 overflow-auto rounded"
    >
      <div
        *ngFor="let issuer of filteredIssuers"
        class="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
        (click)="onIssuerSelect(issuer)"
      >
        {{
          (issuer.issuerId !== null ? issuer.issuerId + "  :  " : "") +
            issuer.asReportedIssuerName
        }}
      </div>
    </div>
  </div>
</div>

<div
  class="grid gap-6 my-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 border border-gray-200 rounded-lg p-6 bg-white"
>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="issuerName"
      [(ngModel)]="formData.issuerName"
      [ngClass]="{
        'border-red-500': validationErrors.issuerName
      }"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'issuerName')"
      (input)="validationErrors.issuerName = ''"
    />
    <label
      class="peer-focus:font-medium absolute text-md text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Issuer Name
    </label>
    <small
      *ngIf="validationErrors.issuerName"
      class="text-red-500 text-xs mt-1 block"
    >
      {{ validationErrors.issuerName }}
    </small>
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="cikNumber"
      [(ngModel)]="formData.cikNumber"
      [ngClass]="{
        'border-red-500': validationErrors.cikNumber
      }"
      class="block py-2.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'cikNumber')"
      (input)="validationErrors.cikNumber = ''"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Cik
    </label>
    <small
      *ngIf="validationErrors.cikNumber"
      class="text-red-500 text-xs mt-1 block"
    >
      {{ validationErrors.cikNumber }}
    </small>
  </div>

  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="ein"
      [(ngModel)]="formData.ein"
      class="block py-2.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'ein')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >EIN</label
    >
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="sicNumber"
      [(ngModel)]="formData.sicNumber"
      class="block py-2.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'sicNumber')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >SIC</label
    >
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="fileNumber"
      [(ngModel)]="formData.fileNumber"
      class="block py-2.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'fileNumber')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >File no</label
    >
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="fiscalYearEnd"
      [(ngModel)]="formData.fiscalYearEnd"
      class="block py-2.5 px-0 w-full text-md text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'fiscalYearEnd')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >Year end</label
    >
  </div>
</div>
<div class="button-group flex justify-end py-3 space-x-2">
  <button
    class="bg-[#1f273b] text-white hover:bg-[#1f273b] text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onUpdate()"
  >
    Update
  </button>
  <button
    class="bg-white hover:bg-gray-100 text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onCancel()"
  >
    Cancel
  </button>
</div>
